import { USER_DATA } from '../user/constant';

export interface PROJECT_ITEM_DATA_RAW {
  id: string;
  createDate: string;
  name: string;
  budget: number;
  restBudget: number;
  uniqueNumber: number;
  responsible: USER_DATA;
}

export interface PROJECT_ITEM_LIST_DATA_RAW {
  list: PROJECT_ITEM_DATA_RAW[];
}

export interface PROJECT_ITEM_DATA extends PROJECT_ITEM_DATA_RAW {
  customName: string;
}

export interface PROJECT_ITEM_LIST_DATA {
  list: PROJECT_ITEM_DATA[];
  isEmpty: boolean;
}

export const API = {
  LIST: {
    TYPE: 'GET',
    URL: '/project/list',
  },
};
